import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LoggingService } from '@pit/core';
import { PinItCoreStoreInitModule } from './pin.it.core.store.init.module';

@NgModule({
    imports: [
        StoreModule,
        EffectsModule,
    ]
})
export class PinItCoreStoreModule {

    constructor(loggingService: LoggingService) {
        loggingService.debug('PinItCoreStoreModule --> constructor()');
    }

    public static forRoot(): ModuleWithProviders<PinItCoreStoreModule> {
        return {
            ngModule: PinItCoreStoreModule,
            providers: []
        };
    }

}
